import { FC, ReactNode } from 'react';
import { Box } from '@mui/material';
import Text from '../text';

interface Props {
  children: ReactNode;
}

const PageBlurb: FC<Props> = ({ children }) => {
  return (
    <Box minHeight={30}>
      <Text color="black">{children}</Text>
    </Box>
  );
};

export default PageBlurb;
